// src/components/InTheNews/InTheNews.js
import React from 'react';
import './News.css'; // Make sure this points to your updated CSS

const articles = [
  {
    title: "Ballet Pointe Shoes: Safety Meets Engineering",
    publication: "Johns Hopkins University Hub",
    date: "June 17, 2025",
    image: "/images/snowF24.jpg",
    link: "https://hub.jhu.edu/2025/06/17/ballet-pointe-shoes-safety-engineering/"
  },
  {
    title: "Engineering Meets Art to Achieve the Perfect Pointe",
    publication: "ASME",
    date: "July 24, 2025",
    image: "/images/ASME_1.jpg",
    link: "https://www.asme.org/topics-resources/content/engineering-meets-art-to-achieve-the-perfect-pointe"
  },
  {
    title: "Podcast: Engineering Better Pointework",
    publication: "ASME",
    date: "July 17, 2025",
    image: "/images/ASME_2.jpg",
    link: "https://www.asme.org/topics-resources/content/podcast-engineering-better-pointework"
  },
  {
    title: "Dance and Biosensors",
    publication: "Dance Magazine",
    date: "November 19, 2025",
    image: "/images/DanceMagazine.png",
    link: "https://dancemagazine.com/dance-and-biosensors/"
  },
  {
    title: "Expanding Arenas: Where Athletics Meets Entrepreneurship ",
    publication: "Johns Hopkins Technology Ventures",
    date: "February 17, 2026",
    image: "/images/PAVA.png",
    link: "https://pavacenter.jhu.edu/news/expanding-arenas-where-athletics-meets-entrepreneurship/"
  },
  {
    title: "TEDCO’s Maryland Innovation Initiative Announces $647,000 Granted to Baltimore Innovation Initiative Awardees",
    publication: "TEDCO",
    date: "February 17, 2026",
    image: "/images/MDSVS.jpg",
    link: "https://www.tedcomd.com/news-events/press-releases/2026/tedcos-maryland-innovation-initiative-announces-647000-granted"
  },
  {
    title: "Pava LaPere’s family announces plans for a new startup foundation at 2026 Student Venture Showcase",
    publication: "Technical.ly",
    date: "February 24, 2026",
    image: "/images/MDSVS.jpg",
    link: "https://technical.ly/entrepreneurship/pava-lapere-foundation-student-venture-showcase-2026/"
  }

];

// Example function to convert date string to a date object
const parseDate = (dateString) => new Date(dateString);

const sortedArticles = articles.sort((a, b) => {
  return parseDate(b.date) - parseDate(a.date); // Sort in descending order
});

const InTheNews = () => {
  return (
    <div className="news-container">
      <div className="news-content-wrapper">
        <h2 className="news-heading">In the News</h2>
        <div className="news-items">
          {sortedArticles.map((article, index) => (
            <div className="news-item" key={index}>
              <a href={article.link} target="_blank" rel="noopener noreferrer">
                <img src={article.image} alt={article.title} className="news-image" />
                <h3>{article.title}</h3>
                <p>{article.publication} | {article.date}</p>
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default InTheNews;